import { useEffect, useState } from 'react';

export const useFeatureFlag = <T extends keyof typeof window.featureFlags>(flag: T): typeof window.featureFlags[T] => {
  const [flagValue, setFlagValue] = useState(window.featureFlags?.[flag]);

  useEffect(() => {
    let shouldCancel = false;

    window.featureFlags = new Proxy(window.featureFlags ?? {}, {
      set(obj, prop, value) {
        const wasPropertySet = Reflect.set(obj, prop, value);
        if (!shouldCancel && wasPropertySet && prop === flag) {
          setFlagValue(value);
        }
        return wasPropertySet;
      },
    });

    return () => {
      shouldCancel = true;
    };
  }, [flag]);

  return flagValue;
};
